module.exports = __webpack_public_path__ + "img/sobg.7daf4ac1.jpg";